(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["compre-junto--list"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    const checkboxes = document.querySelectorAll(".product-buy-together-wrapper .product-item-checkmark");

    const btns = document.querySelectorAll(".product-buy-together-wrapper .btn-quantity");

    function updateAccessoryTotals() {
      let totalPrice = 0;
      let totalComparePrice = 0;

      document.querySelectorAll('.product-buy-together-wrapper .product-item[data-checked="true"]').forEach((item) => {
        totalPrice += Number(item.dataset.price || 0) * Number(item.dataset.currentQuantity);
        totalComparePrice += Number(item.dataset.compareAtPrice || 0) * Number(item.dataset.currentQuantity);
      });

      const totalSelectedEl = document.querySelector(".product-buy-together .total-selected");
      const totalCompareSelectedEl = document.querySelector(".product-buy-together .total-compare-selected");

      if (totalSelectedEl) {
        totalSelectedEl.textContent = Shopify.formatMoney(totalPrice, window.money_format);
      }

      if (totalCompareSelectedEl) {
        totalCompareSelectedEl.textContent = Shopify.formatMoney(totalComparePrice, window.money_format);

        if (totalPrice >= totalComparePrice) {
          totalCompareSelectedEl.classList.add("hidden");
        } else {
          totalCompareSelectedEl.classList.remove("hidden");
        }
      }
    }

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", function () {
        const productItem = this.closest(".product-item");
        if (!productItem) return;

        productItem.dataset.checked = this.checked ? "true" : "false";
        updateAccessoryTotals();
      });
    });

    btns.forEach((btn) => {
      btn.addEventListener("click", function () {
        const productItem = this.closest(".product-item");
        const wrapper = this.closest(".card-qt-wrapper");
        const input = wrapper.querySelector("input");
        if (!productItem) return;

        if (this.classList.contains("plus") && Number(input.value) < Number(input.dataset.inventoryQuantity)) {
          input.value = Number(input.value) + 1;
        } else if (Number(input.value) > 1) {
          input.value -= 1;
        }

        productItem.dataset.currentQuantity = input.value;
        updateAccessoryTotals();
      });
    });

    updateAccessoryTotals();

    const compreJuntoButton = document.querySelector(".compre-junto-btn");
    compreJuntoButton.addEventListener("click", function () {
      let formData = {
        items: [],
      };
      const ids = document
        .querySelectorAll('.product-buy-together-wrapper .product-item[data-checked="true"]')
        .forEach((item) => {
          formData.items.push({ id: item.dataset.productVariantId, quantity: item.dataset.currentQuantity });
        });

      if (formData.items.length > 0) {
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            Shopify.getCart((cart) => {
              window.updateCart(cart);
            });
            return response.json();
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
